import styled from 'styled-components/macro';
import { breakPoints } from '../../../config/config';
import { darkerGray } from '../../../config/colors';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
  padding: 35px 20px 0 20px;
`;

export const LogoWrapper = styled.div`
  text-align: center;
  margin-bottom: 30px;
  & img {
    width: 160px;
    height: auto;
  }
`;

export const InnerWrapper = styled.div`
  width: ${({ width }) => (width ? `${width}px` : '460px')};
  margin: 35px 20px 0 20px;
`;

export const Content = styled.form`
  border-radius: 10px;
  box-shadow: 0px 2px 10px #37465f26;
  padding: 42px;
  background-color: white;
  color: ${darkerGray};
  @media (max-width: ${breakPoints.tabletWidth}px) {
    padding: 25px 20px;
  }
`;

export const Title = styled.h1`
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
  padding-top: 16px;
  text-align: center;
  max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}px` : '430px')};
  margin: 0 auto;
`;

export const Text = styled.p`
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin: 0;
  padding-top: 40px;
`;
